import { createEntityAdapter } from '@ngrx/entity';
import { User, Chat } from '@app/core/models';

export const selectContactId = (user: {
  userID: string;
  userType: User.Type;
}) => user.userID + user.userType;

export const contactAdapter = createEntityAdapter<Chat.Contact>({
  selectId: selectContactId,
  sortComparer: (user1, user2) => {
    const userName1 = `${user1.firstName} ${user1.lastName}`;
    const userName2 = `${user2.firstName} ${user2.lastName}`;
    return userName1.localeCompare(userName2);
  },
});
